module.exports = __webpack_public_path__ + "images/meater-report-mockup_51ed9e6.png";